import { render, staticRenderFns } from "./index.vue?vue&type=template&id=4ab07e00&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=4ab07e00&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ab07e00",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/app/erp_frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4ab07e00')) {
      api.createRecord('4ab07e00', component.options)
    } else {
      api.reload('4ab07e00', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=4ab07e00&scoped=true", function () {
      api.rerender('4ab07e00', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/center-business/logistics/company/list/index.vue"
export default component.exports